
      var _path, _path2, _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 43h89v12h-89V43Z",
  fill: "url(#payment_793144959404238c__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M71.5 77h22",
  stroke: "url(#payment_793144959404238c__b)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 31,
  width: 88,
  height: 58,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 4.4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10.5,
  y: 64,
  width: 38,
  height: 38,
  rx: 19,
  fill: "#fff"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10.5,
  y: 64,
  width: 38,
  height: 38,
  rx: 19,
  stroke: "#fff",
  strokeWidth: 4.4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#payment_793144959404238c__c)",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.625 91.651c.808.266 1.7-.064 2.038-.835l1.992-4.51c.359-.809-.077-1.75-.941-2.126l-.008-.003-.246-.082-.007-.003v.001c-.727-.187-1.495.094-1.849.722l-.065.13-.515 1.162-.017-.035c-.803-1.648-.963-3.473-.428-5.121l.15-.412c1.012-2.504 3.47-4.145 6.435-4.274l.17-.016c.841-.118 1.44-.833 1.332-1.676-.077-.604-.504-1.118-1.084-1.353a1.823 1.823 0 0 0-.564-.13l-.192-.001c-4.232.183-7.784 2.548-9.25 6.18-.989 2.448-.872 5.207.247 7.695l.001.001.018.04-1.135-.494-.008-.003-.246-.083-.007-.002c-.774-.2-1.596.135-1.915.852v.001c-.356.808.08 1.749.927 2.117l4.791 2.068.06.044.01.007.137.075.008.004.16.06Z",
  fill: "url(#payment_793144959404238c__d)",
  stroke: "url(#payment_793144959404238c__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.333 91.427c.11.871.937 1.522 1.84 1.484h.001c4.232-.184 7.784-2.549 9.25-6.18.989-2.448.872-5.206-.247-7.694v-.003l-.019-.036 1.104.478.146.059c.69.245 1.454.038 1.874-.499l.086-.12.003-.006.095-.18.003-.006.058-.153c.242-.77-.188-1.618-.983-1.963l-4.79-2.067-.064-.046-.01-.007v.001l-.15-.082-.008-.004-.009-.002-.245-.084-.007-.001c-.726-.187-1.493.092-1.842.706l-.063.126-2.012 4.548c-.355.806.078 1.746.912 2.11.843.387 1.848.058 2.206-.751l.512-1.163.02.037c.801 1.647.961 3.47.427 5.117l-.15.411-.099.233c-1.066 2.374-3.463 3.92-6.337 4.045-.928.04-1.616.794-1.502 1.692Z",
  fill: "url(#payment_793144959404238c__f)",
  stroke: "url(#payment_793144959404238c__g)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment_793144959404238c__a",
  x1: 104,
  y1: 55,
  x2: -2.5,
  y2: 40.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment_793144959404238c__b",
  x1: 94.5,
  y1: 79,
  x2: 69,
  y2: 74.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment_793144959404238c__d",
  x1: 20.006,
  y1: 90.491,
  x2: 27.306,
  y2: 72.409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment_793144959404238c__e",
  x1: 20.006,
  y1: 90.491,
  x2: 27.306,
  y2: 72.409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment_793144959404238c__f",
  x1: 31.694,
  y1: 93.592,
  x2: 38.994,
  y2: 75.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "payment_793144959404238c__g",
  x1: 31.694,
  y1: 93.592,
  x2: 38.994,
  y2: 75.51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "payment_793144959404238c__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "scale(1 -1) rotate(-21.984 -227.943 -74.4)",
  d: "M0 0h28v28H0z"
})))));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M17.5 43H106.5V55H17.5V43Z\" fill=\"url(#paint0_linear_8631_156723)\"/>\r\n<path d=\"M71.5 77H93.5\" stroke=\"url(#paint1_linear_8631_156723)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<rect x=\"17.5\" y=\"31\" width=\"88\" height=\"58\" rx=\"6\" stroke=\"white\" stroke-width=\"4.4\"/>\r\n<rect x=\"10.5\" y=\"64\" width=\"38\" height=\"38\" rx=\"19\" fill=\"white\"/>\r\n<rect x=\"10.5\" y=\"64\" width=\"38\" height=\"38\" rx=\"19\" stroke=\"white\" stroke-width=\"4.4\"/>\r\n<g clip-path=\"url(#clip0_8631_156723)\">\r\n<path d=\"M22.6249 91.6514C23.4332 91.9165 24.3241 91.5865 24.6632 90.8155L26.6555 86.3057C27.0138 85.4973 26.5776 84.5555 25.7137 84.1804L25.7055 84.1771L25.4597 84.0947L25.4534 84.0922L25.453 84.0931C24.7257 83.906 23.9583 84.1873 23.6041 84.8147L23.5387 84.9453L23.0245 86.1068L23.0069 86.0723C22.2036 84.4241 22.0439 82.5986 22.5795 80.951L22.7291 80.5386C23.7415 78.0351 26.1994 76.3941 29.1642 76.2647L29.3347 76.2493C30.1751 76.1314 30.7739 75.4158 30.6664 74.5732C30.589 73.9685 30.1623 73.4546 29.5823 73.2204C29.4025 73.1478 29.2117 73.1032 29.0185 73.0907L28.8256 73.0887C24.5937 73.2724 21.0418 75.6374 19.5754 79.2696C18.5875 81.7169 18.7038 84.4758 19.8225 86.9636L19.824 86.9652L19.8425 87.0053L18.7067 86.511L18.6986 86.5077L18.4527 86.4253L18.4464 86.4228C17.6716 86.2236 16.8499 86.5575 16.5309 87.2755L16.5305 87.2764C16.1751 88.0842 16.6104 89.0245 17.458 89.3927L22.2491 91.4607L22.3091 91.5049L22.3189 91.512L22.3193 91.5111L22.4563 91.5865L22.4641 91.5906L22.6249 91.6514Z\" fill=\"url(#paint2_linear_8631_156723)\" stroke=\"url(#paint3_linear_8631_156723)\" stroke-width=\"0.2\"/>\r\n<path d=\"M28.3334 91.4273C28.4439 92.2984 29.2698 92.949 30.1733 92.9115L30.1742 92.9118C34.4061 92.7271 37.9583 90.3625 39.4244 86.7309C40.4126 84.2831 40.2959 81.5246 39.1773 79.0369L39.1762 79.0344L39.1584 78.9977L40.2618 79.4758L40.4085 79.535C41.0973 79.7803 41.8619 79.5734 42.2823 79.0361L42.3677 78.9158L42.3712 78.9098L42.4659 78.7301L42.4693 78.7241L42.5268 78.5714C42.7691 77.8012 42.3386 76.9529 41.544 76.6076L36.7544 74.5413L36.6898 74.4952L36.68 74.4881L36.6797 74.489L36.5294 74.4073L36.5216 74.4031L36.5131 74.4007L36.2677 74.3174L36.261 74.3157C35.5349 74.1288 34.7684 74.4083 34.4195 75.0215L34.3556 75.1484L32.344 79.6957C31.9891 80.5022 32.4222 81.4424 33.2561 81.8058C34.0995 82.1934 35.1038 81.8636 35.4624 81.0547L35.9739 79.8921L35.9939 79.9286C36.7954 81.5755 36.9553 83.3992 36.4209 85.0455L36.2716 85.457L36.1724 85.6897C35.1056 88.0645 32.7093 89.6102 29.8348 89.7354C28.9066 89.7757 28.2187 90.5295 28.3334 91.4273Z\" fill=\"url(#paint4_linear_8631_156723)\" stroke=\"url(#paint5_linear_8631_156723)\" stroke-width=\"0.2\"/>\r\n</g>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_8631_156723\" x1=\"104\" y1=\"55\" x2=\"-2.5\" y2=\"40.5\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint1_linear_8631_156723\" x1=\"94.5\" y1=\"79\" x2=\"69\" y2=\"74.5\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint2_linear_8631_156723\" x1=\"20.0057\" y1=\"90.4907\" x2=\"27.3056\" y2=\"72.4087\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint3_linear_8631_156723\" x1=\"20.0057\" y1=\"90.4907\" x2=\"27.3056\" y2=\"72.4087\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint4_linear_8631_156723\" x1=\"31.6943\" y1=\"93.5918\" x2=\"38.9942\" y2=\"75.5097\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<linearGradient id=\"paint5_linear_8631_156723\" x1=\"31.6943\" y1=\"93.5918\" x2=\"38.9942\" y2=\"75.5097\" gradientUnits=\"userSpaceOnUse\">\r\n<stop stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n<clipPath id=\"clip0_8631_156723\">\r\n<rect width=\"28\" height=\"28\" fill=\"white\" transform=\"matrix(0.927286 0.374353 0.374353 -0.927286 11.2771 90.7412)\"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/payment.793144959404238c57ae9c7d00ae2fab.svg"),
        {
          React: SvgPayment,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      